import translateService from '@widgets/shared/services/translate/translateService'
import type { CastCommonErrorToMessagesCallback } from '@/composition/widgetForm'

export const castCommonErrorToMessages: CastCommonErrorToMessagesCallback = (status) => {
  if (status === 429) {
    return [translateService.t('common.messageNotSent')]
  }
  if (status && [404, 403].includes(status)) {
    return [translateService.t('common.channelNotAvailable')]
  }
  return undefined
}
